import { render } from "./HeroiconsSolidEmojiHappy.vue?vue&type=template&id=6f2e3b76"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidEmojiHappy.vue"]])

export default __exports__